import { ProductKey } from "@/components/signup/utils";

export const defaultProduct = {
    bundle: "jira-software",
    description: "Jira",
    key: ProductKey.JIRA_SOFTWARE,
    name: "jira"
} as const;

export const products = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: ProductKey.JIRA_SOFTWARE,
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: ProductKey.CONFLUENCE,
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: ProductKey.JIRA_SERVICE_MANAGEMENT,
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: ProductKey.JIRA_PRODUCT_DISCOVERY,
        name: "jira-product-discovery"
    },
    {
        bundle: "beacon",
        description: "Beacon",
        key: ProductKey.BEACON,
        name: "beacon"
    },
    {
        bundle: "bitbucket",
        description: "Bitbucket",
        key: ProductKey.BITBUCKET,
        name: "bitbucket"
    },
    {
        bundle: "compass",
        description: "Compass",
        key: ProductKey.COMPASS,
        name: "compass"
    },
    {
        bundle: "fabric",
        description: "Fabric",
        key: ProductKey.FABRIC,
        name: "fabric"
    },
    {
        bundle: "loom",
        description: "Loom",
        key: ProductKey.LOOM,
        name: "loom"
    },
    {
        bundle: "opsgenie",
        description: "Opsgenie",
        key: ProductKey.OPSGENIE,
        name: "opsgenie"
    },
    {
        bundle: "statuspage",
        description: "Statuspage",
        key: ProductKey.STATUSPAGE,
        name: "statuspage"
    }
] as const;

export type Product = (typeof products)[number];
